import { Node } from 'slate'
import { SlateReactPresentation } from 'slate-react-presentation'
import { ElementComponent } from './ElementComponent'
import { LeafComponent } from './LeafComponent'

interface ReadOnlyRichtextProps {
    document: Node[]
}
export function ReadOnlyRichtext({ document }: ReadOnlyRichtextProps) {
    return (
        <SlateReactPresentation
            value={document}
            renderElement={(props) => <ElementComponent {...props} />}
            renderLeaf={(props) => <LeafComponent {...props} />}
        />
    )
}
